import { RubleSymbol } from '@r1-frontend/ui-react/experimental/purchase/cost/Cost/RubleSymbol';

import InfoBlock from '~/src/features/full-buy/InfoBlock';
import { PaymentVariants } from '~/src/features/full-buy/PaymentVariants';

import OrderSummary from '../containers/OrderSummary';

import * as ST from './styled';

interface IProps {
    totalCost: number,
    agreementNumber?: number | null,
    hasError?: boolean,
}

export const TicketFinal = (
    {
        totalCost,
        agreementNumber,
        hasError,
    }: IProps,
): JSX.Element => {
    return (
        <InfoBlock
            header={!hasError ? `Оплатить можно только ${'\n'}до или во время визита инженера` : ''}
            title={!hasError ? `К оплате: ${totalCost} ${RubleSymbol}` : 'Стоимость услуг'}
            isCollapsable={true}
            isRightSide={true}
            bottomContent={agreementNumber
                ? <ST.StyledTicket>
                    <PaymentVariants
                        paySumm={totalCost}
                        agreementNumber={agreementNumber}
                        isLastStep={true}
                    />
                </ST.StyledTicket>
                : undefined}
        >
            <OrderSummary withoutTitle/>
        </InfoBlock>
    );
};
